export enum FetchStatus {
    Idle, Fetching, Success, Fail,
}
